import './QrLabelFields.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';

import { TEMPLATE_FIELD_TYPE, FGT_REDIRECT_BASE } from '../../constants';
import options from '../../utils/options';

class QrLabelFields extends Component {

    buildValue = (type, value) => {
        switch (type) {
            case TEMPLATE_FIELD_TYPE.BARCODE.value:
                return (<Barcode width={1} height={7} displayValue={false} value={value} margin={0} />);
            // adding the conditional in the case statement renders a url an not a qr code?
            case TEMPLATE_FIELD_TYPE.QR.value:
                // this QRCode module isn't smart enough to not accept undefined 🤦🤷 so we need to filter out any 'undefined' values
                if (value) {
                    return (<QRCode size={55} value={value} />);
                }
                break;
            case TEMPLATE_FIELD_TYPE.IMG.value:
                return (<img src={value} alt={value} />);
            case TEMPLATE_FIELD_TYPE.DATE.value:
                return (<span>{options.getDate(value, TEMPLATE_FIELD_TYPE.DATE.value)}</span>);
            case TEMPLATE_FIELD_TYPE.DATE_TIME.value:
                return (<span>{options.getDate(value, TEMPLATE_FIELD_TYPE.DATE_TIME.value)}</span>);
            default:
                return (<span>{value}</span>);
        }
    }

    buildField = ({ label, value, type }) => {
        const array = label.split('] - ');

        return (
            <div className={'LabelField'}>
                <div className={'Label'}>{array[array?.length - 1]}</div>
                <div className={`Value ${type}`}>
                    {this.buildValue(type, value)}
                </div>
            </div>
        );
    }

    render() {
        const { fields, rows, hashId, partId } = this.props;

        let filtered = fields;

        const left = filtered.slice(0, rows);
        const right = filtered.slice(rows, rows * 2);

        return (
            <div className={'QrLabelFields'}>
                <div className={'Left'}>
                    {left.map((f) => this.buildField(f, hashId, partId))}
                </div>
                <div className={'Center'}>
                    {right.map((f) => this.buildField(f, hashId, partId))}
                </div>
                <div className='QrCode'>
                    <QRCode size={55} className={'QrCode'} value={`${FGT_REDIRECT_BASE}/${hashId}/${partId}`} />
                    {/* <div className='ScanText'>Scan For Parts</div> */}
                </div>
            </div>
        );
    }
}

QrLabelFields.defaultProps = {
    fields: [],
    rows: 5,
    hashId: undefined,
    partId: undefined
};

QrLabelFields.propTypes = {
    fields: PropTypes.array.isRequired,
    rows: PropTypes.number,
    hashId: PropTypes.string,
    partId: PropTypes.string
};


export default QrLabelFields;
